import { render, staticRenderFns } from "./OrderkufangDetails.vue?vue&type=template&id=855a8f04&scoped=true"
import script from "./OrderkufangDetails.vue?vue&type=script&lang=js"
export * from "./OrderkufangDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderkufangDetails.vue?vue&type=style&index=0&id=855a8f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855a8f04",
  null
  
)

export default component.exports